import { render, staticRenderFns } from "./PressRow2.vue?vue&type=template&id=03e8d40c"
import script from "./PressRow2.vue?vue&type=script&lang=js"
export * from "./PressRow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports